module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. I will answer to the message as soon as possible.</p>","frontmatter":{"title":"Success"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<p>Intelligencer Copyright 2019 Christopher Mitchell</p>"},"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{"slug":"/success/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/success.json
// module id = 830
// module chunks = 170786371021445